<div class="card">
  <rqa-page-title [title]="'users.title' | translate">
    <p-button icon="pi pi-plus" [label]="'users.form.add' | translate" class="p-button-sm" (click)="openAdd()" />
  </rqa-page-title>
  <p-table
    #usersTable
    [value]="users"
    [scrollable]="true"
    [tableStyle]="{ 'min-width': '75rem' }"
    [scrollHeight]="tableScrollHeight"
    dataKey="username"
    [globalFilterFields]="['firstName', 'lastName', 'username']"
    styleClass="p-datatable-sm"
  >
    <ng-template pTemplate="header">
      <tr>
        <th colspan="14">
          <div class="flex items-center justify-between mb-3">
            <div class="flex items-center gap-2 w-1/2">
              <div class="flex-1">
                <label for="search" class="block mb-1 text-sm">{{ 'users.search.label' | translate }}</label>
                <input
                  pInputText
                  id="search"
                  type="text"
                  (input)="filterUsers($event, 'contains')"
                  [placeholder]="'users.search.placeholder' | translate"
                  class="w-full"
                />
              </div>

              <div>
                <label for="enabled" class="block mb-1 text-sm">{{ 'users.table.header.enabled' | translate }}</label>
                <p-select
                  id="enabled"
                  [options]="[
                    { label: 'users.search.enabled.yes' | translate, value: true },
                    { label: 'users.search.enabled.no' | translate, value: false }
                  ]"
                  class="w-32"
                  (onChange)="onSelect($event)"
                ></p-select>
              </div>
              <button pButton type="button" icon="pi pi-refresh" (click)="refresh()" class="self-end"></button>
            </div>
          </div>
        </th>
      </tr>

      <tr>
        <th></th>

        <th>{{ 'users.table.header.number' | translate }}</th>

        <th pSortableColumn="username">
          {{ 'users.table.header.username' | translate }}
          <p-sortIcon field="username"></p-sortIcon>
        </th>

        <th pSortableColumn="firstName">
          {{ 'users.table.header.firstName' | translate }}
          <p-sortIcon field="firstName"></p-sortIcon>
        </th>

        <th pSortableColumn="lastName">
          {{ 'users.table.header.lastName' | translate }}
          <p-sortIcon field="lastName"></p-sortIcon>
        </th>

        <th pSortableColumn="organization">
          {{ 'users.table.header.organization' | translate }}
          <p-sortIcon field="organization"></p-sortIcon>
        </th>

        <th pSortableColumn="group">
          {{ 'users.table.header.type' | translate }}
          <p-sortIcon field="group"></p-sortIcon>
        </th>

        <th pSortableColumn="responsibleUnit">
          {{ 'users.table.header.respUnit' | translate }}
          <p-sortIcon field="responsibleUnit"></p-sortIcon>
        </th>

        <th pSortableColumn="role">
          {{ 'users.table.header.role' | translate }}
          <p-sortIcon field="role"></p-sortIcon>
        </th>

        <th pSortableColumn="enabled">
          {{ 'users.table.header.enabled' | translate }}
          <p-sortIcon field="enabled"></p-sortIcon>
        </th>

        <th></th>

        <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-user let-i="rowIndex" let-expanded="expanded">
      <tr>
        <td>
          <p-checkbox
            [binary]="true"
            [ngModel]="messageList.includes(user.username)"
            (onChange)="addToMailList(user.username, $event)"
          ></p-checkbox>
        </td>

        <td>{{ i + 1 }}</td>

        <td>{{ user.username }}</td>

        <td>{{ user.firstName }}</td>

        <td>{{ user.lastName }}</td>

        <td>{{ user.organization }}</td>

        <td>{{ user.group }}</td>

        <td>{{ user.responsibleUnit }}</td>

        <td>{{ user.role }}</td>

        <td class="text-center">
          <i
            [class]="user.enabled ? 'pi pi-check-circle text-green-500' : 'pi pi-times-circle text-red-500'"
            [pTooltip]="(user.enabled ? 'users.search.enabled.yes' : 'users.search.enabled.no') | translate"
          ></i>
        </td>

        <td>
          <div class="flex">
            <p-button
              type="button"
              pRipple
              [pRowToggler]="user"
              [text]="true"
              severity="secondary"
              [rounded]="true"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
            />
            <button
              pButton
              type="button"
              icon="pi pi-ellipsis-v"
              class="p-button-text p-button-sm"
              (click)="menu.toggle($event)"
            ></button>

            <p-menu
              #menu
              [popup]="true"
              [model]="rowMenuItems"
              [appendTo]="'body'"
              [baseZIndex]="1000"
              styleClass="custom-menu"
              (onShow)="onShowMenu(user)"
            ></p-menu>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template #expandedrow let-user>
      <tr>
        <td colspan="14">
          <div>
            <table class="w-1/2 text-sm">
              <tr class="border-b border-gray-200">
                <td class="font-bold p-2">{{ 'users.table.header.email' | translate }}</td>
                <td>{{ user.email }}</td>
              </tr>
              <tr class="border-b border-gray-200">
                <td class="font-bold p-2">{{ 'users.table.header.phone' | translate }}</td>
                <td>
                  @for (phone of user.phone; track phone) {
                    {{ phone }};
                  }
                </td>
              </tr>
              <tr class="border-b border-gray-200">
                <td class="font-bold p-2">{{ 'users.table.header.time' | translate }}</td>
                <td>{{ user.time }}</td>
              </tr>
              <tr class="border-b border-gray-200">
                <td class="font-bold p-2">{{ 'users.table.header.locale' | translate }}</td>
                <td>{{ user.locale }}</td>
              </tr>
              <tr>
                <td class="font-bold p-2">{{ 'users.table.header.observation' | translate }}</td>
                <td>{{ user.observation }}</td>
              </tr>
            </table>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="footer">
      <tr>
        <td colspan="14">
          <div class="flex justify-start gap-2">
            <p-button
              type="button"
              variant="text"
              icon="pi pi-envelope"
              [label]="'users.actions.sendMessage' | translate"
              class="p-button-sm"
              [disabled]="messageList.length === 0"
              (click)="sentMessage()"
            />

            <p-button
              type="button"
              variant="text"
              icon="pi pi-envelope"
              [label]="'users.actions.sendMessageToAll' | translate"
              class="p-button-sm"
              (click)="sentMessage(true)"
            />
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
